import { makeHook } from "../../utils/makeSingleArgHook";
import getPortfolioAssetClasses, { portfolioAssetClassesURL, } from "../request/getPortfolioAssetClasses";
import { ALL_PORTFOLIOS } from "./constants";
export const portfolioAssetClassesKeyMaker = (portfolioPlanId) => [
    portfolioAssetClassesURL(ALL_PORTFOLIOS),
    portfolioAssetClassesURL(portfolioPlanId),
];
const useGetPortfolioAssetClasses = makeHook(getPortfolioAssetClasses, portfolioAssetClassesKeyMaker);
export default useGetPortfolioAssetClasses;
//# sourceMappingURL=useGetPortfolioAssetClasses.js.map